// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cart_wrapper__HK5BX","icon":"cart_icon__9GCLO","number":"cart_number__LM0nW"};